import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EnvironmentUtils from '../utils/environment-utils';
import { ProfileContext } from '../contexts/profile.context';

const Viewer = () => {
  const { code } = useParams<{code: string}>();
  const { handleHideOnboarding } = useContext(ProfileContext);

  handleHideOnboarding();

  useEffect(() => {
    document?.getElementsByTagName?.('body')?.[0]?.classList?.add?.("viewer-body");
  }, []);

  return <iframe
    title="task viewer"
    src={ `${ EnvironmentUtils.getVar('PREVIEW_URL') }/${ code }` }
    style={{width: '100%', height: '100%', border: 'none'}}
  />;
}

export default Viewer;
